import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr, withXsrfConfiguration } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { GlobalErrorHandler } from '@services/error-handler.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { authInterceptor } from '../_interceptors/auth.interceptor';
import { miniProfilerInterceptor } from '../_interceptors/mini-profiler.interceptor';
import { routes } from './app.routes';
import { NAVIGATOR, WINDOW } from './tokens/window.tokens';

import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localeKo from '@angular/common/locales/ko';
import localeZh from '@angular/common/locales/zh';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeIt, 'it');
registerLocaleData(localeJa, 'ja');
registerLocaleData(localeZh, 'zh');
registerLocaleData(localeKo, 'ko');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDa, 'da');

export function getLocale(): string {
	return localStorage.getItem('locale') || 'en';
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideAnimations(),
		provideRouter(routes),
		provideHttpClient(withXhr(), withInterceptorsFromDi(),
			withXsrfConfiguration({
				cookieName: 'XSRF-TOKEN',
				headerName: 'X-XSRF-TOKEN'
			}),
			withInterceptors([
				authInterceptor,
				miniProfilerInterceptor,
			])),
		provideNgxWebstorage(
			withNgxWebstorageConfig({ caseSensitive: true }),
			withLocalStorage(),
			withSessionStorage()
		),
		DeviceDetectorService,
		provideHttpClient(),
		provideTranslateService({
			loader: provideTranslateHttpLoader({
				prefix: '/assets/i18n/',
				suffix: '.json'
			}),
			fallbackLang: 'en',
			lang: 'en'
		}),
		{ provide: LOCALE_ID, useFactory: getLocale },
		{ provide: WINDOW, useValue: window },
		{ provide: NAVIGATOR, useValue: navigator },
		{
			provide: ErrorHandler,
			useClass: GlobalErrorHandler
		},
	]
};
